/**
 * Unified FAB Store — Speed Dial state management
 * Egy helyen kezeli az összes floating drawer-t (Helpdesk, Chat, pRI)
 */
import { create } from 'zustand';

export type DrawerType = 'helpdesk' | 'chat' | 'pri';

interface UnifiedFabState {
  menuOpen: boolean;
  activeDrawer: DrawerType | null;
  badges: Record<DrawerType, number>;
  // Actions
  toggleMenu: () => void;
  closeMenu: () => void;
  openDrawer: (drawer: DrawerType) => void;
  closeDrawer: () => void;
  setBadge: (key: DrawerType, count: number) => void;
}

export const useUnifiedFabStore = create<UnifiedFabState>(set => ({
  menuOpen: false,
  activeDrawer: null,
  badges: { helpdesk: 0, chat: 0, pri: 0 },

  toggleMenu: () => set(s => ({ menuOpen: !s.menuOpen })),

  closeMenu: () => set({ menuOpen: false }),

  openDrawer: drawer => set({ activeDrawer: drawer, menuOpen: false }),

  closeDrawer: () => set({ activeDrawer: null }),

  setBadge: (key, count) => set(s => ({ badges: { ...s.badges, [key]: count } })),
}));
